import Ajax from '../services/Ajax';

export default class Payment {
  getReturnUrl() {
    let returnUrl = window.location.origin;
    return returnUrl;
  }

  async transaction(reference: string, method: string) {
    const { data } = await Ajax.post(`payment/transaction/${reference}`, {
      payment_method: method,
      return_url: this.getReturnUrl(),
    });
    return data;
  }

  async montonioTransaction(reference: string, methodCode: string) {
    const { data } = await Ajax.post(`v2/payment/transaction/${reference}`, {
      paymentMethod: methodCode,
      returnUrl: this.getReturnUrl(),
    });
    return data;
  }

  async inbank(reference: string, methodName: string) {
    const { data } = await Ajax.post(
      `payment/inbank/${methodName}/order/${reference}`,
      {
        return_url: this.getReturnUrl(),
      },
    );
    return data;
  }

  async modena(reference: string) {
    const { data } = await Ajax.post(`payment/modena/order/${reference}`, {
      returnUrl: this.getReturnUrl(),
    });
    return data;
  }
}
